import { render } from "./ManageTeams.vue?vue&type=template&id=74cb0c8a&scoped=true"
import script from "./ManageTeams.vue?vue&type=script&lang=js"
export * from "./ManageTeams.vue?vue&type=script&lang=js"

import "./ManageTeams.vue?vue&type=style&index=0&id=74cb0c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cb0c8a"]])

export default __exports__